/**
 * Product detection utility
 * Determines the product type based on the subdomain
 */

export const PRODUCT_TYPES = {
    DTO: "dto",
    MLTA: "mlta",
    GIWL: "giwl",
};

export const PRODUCT_CODES = {
    DTO: "DMTERM",
    MLTA: "MLTA",
    GIWL: "GIWL",
};

const SUBDOMAIN_TO_PRODUCT = {
    directterm: PRODUCT_TYPES.DTO,
    loyalty: PRODUCT_TYPES.MLTA,
    giwl: PRODUCT_TYPES.GIWL,
    localhost: PRODUCT_TYPES.DTO, // Default for local development
};

/**
 * Detects the product type from the current subdomain or query parameter
 * Query parameter is used as fallback for testing environments where subdomain DNS is not available
 * @returns {string} Product type ('dto', 'mlta', or 'giwl')
 */
export const getProductFromSubdomain = () => {
    // Check query parameter first (for testing environments)
    const urlParams = new URLSearchParams(window.location.search);
    const subdomainParam = urlParams.get("subdomain");

    if (subdomainParam && SUBDOMAIN_TO_PRODUCT[subdomainParam]) {
        return SUBDOMAIN_TO_PRODUCT[subdomainParam];
    }

    // Fall back to hostname subdomain (for production)
    const hostname = window.location.hostname;
    const subdomain = hostname.split(".")[0];

    return SUBDOMAIN_TO_PRODUCT[subdomain] || PRODUCT_TYPES.DTO;
};

/**
 * Checks if the current product is DTO
 * @returns {boolean}
 */
export const isDTO = () => getProductFromSubdomain() === PRODUCT_TYPES.DTO;

/**
 * Checks if the current product is MLTA
 * @returns {boolean}
 */
export const isMLTA = () => getProductFromSubdomain() === PRODUCT_TYPES.MLTA;

/**
 * Checks if the current product is GIWL
 * @returns {boolean}
 */
export const isGIWL = () => getProductFromSubdomain() === PRODUCT_TYPES.GIWL;
